import React, { Suspense, lazy } from 'react';
import { Switch, Route } from 'react-router-dom';
import LoginLayout from 'src/ui/features/Login/presentational/layout/LoginLayoutPres';
import { updateBodyClass } from 'src/helpers';
import { LOGIN_URL, BODY_CLASSES } from 'src/constants/constants.js';
import ServiceSpinner from 'src/ui/library/ServiceSpinner';

//Lazy Load
const LoginContainer = lazy(() => import('src/ui/features/Login/containers/LoginContainer'));

class LoginRoot extends React.Component {
  componentDidMount() {
    sessionStorage.removeItem('CN');
    updateBodyClass(BODY_CLASSES.LOGIN);
  }

  componentWillUnmount() {
    updateBodyClass(BODY_CLASSES.LOGIN);
  }

  render() {
    return (
      <LoginLayout skipAuth={true}>
        <Suspense fallback={<ServiceSpinner open={true} />}>
          <Switch>
            <Route path={LOGIN_URL} render={props => <LoginContainer {...props} />} />
          </Switch>
        </Suspense>
      </LoginLayout>
    );
  }
}

export default LoginRoot;



// WEBPACK FOOTER //
// ./src/ui/features/Login/index.js